
import { PatientDto, GeneralPractitioner } from "../../../dto/PatientDto";
import Dal from './../../../scripts/dataaccess'

import { IFormElementController, FormElementController, FormPageValidator, FormElementValidator, StringValidators} from './../../../scripts/formcontrols'

enum Sex {
    Male,
    Female,
    Unspecified
}

export class CarehomePatientCreateController extends FormPageValidator {

    public title: FormElementController<string>;
    public firstName: FormElementController<string>;
    public middleName: FormElementController<string>;
    public lastName: FormElementController<string>;
    public dob: FormElementController<Date>;
    public sex: FormElementController<string>;
    public notes: FormElementController<string>;
    public allergies: FormElementController<string>;
    public nhsnumber: FormElementController<string>;

    public gpname: FormElementController<string>;
    public gpaddress: FormElementController<string>;
    public gppostcode: FormElementController<string>;
    public gpphone: FormElementController<string>;

    public image: string;

    private carehomeId: string;
    private patient: PatientDto;
    public IsNew: boolean;

    constructor(carehomeid :string, patient: PatientDto) {
        super();

        this.carehomeId = carehomeid;
        var obj = { a: 1 };

       
        
        if (!patient || patient == null) {
            this.IsNew = true;
            patient = new PatientDto();
            patient.generalPractitioner = new GeneralPractitioner();
            this.patient = patient;
        } else {
            this.IsNew = false;
            this.patient = Object.assign({}, patient) as PatientDto;
        }

        var titleValidator = new FormElementValidator<string>(true);
        var firstNameValidator = new FormElementValidator<string>(true);
        var lastNameValidator = new FormElementValidator<string>(true);
        var dobValidator = new FormElementValidator<Date>(true);
        var sexValidator = new FormElementValidator<string>(true);

        this.addValidators(titleValidator, firstNameValidator, lastNameValidator, dobValidator, sexValidator);

        var capitalize = (v: string): string => {
            if (v) {
                return v.charAt(0).toUpperCase() + v.slice(1);
            }
            return "";
        }
        this.title = new FormElementController<string>("Title", patient.title || "", titleValidator, capitalize);
        this.firstName = new FormElementController<string>("First Name", patient.firstName || "", firstNameValidator, capitalize);
        this.middleName = new FormElementController<string>("Middle Name", patient.middleName || "", undefined, capitalize);
        this.lastName = new FormElementController<string>("Last Name", patient.lastName || "", lastNameValidator, capitalize);

        this.dob = new FormElementController<Date>("Dob", patient.dob, dobValidator);

        this.sex = new FormElementController<string>("Sex", patient.sex || "", sexValidator);
        this.notes = new FormElementController<string>("Notes", patient.notes || "");
        this.allergies = new FormElementController<string>("Allergies", patient.allergies || "");
        this.nhsnumber = new FormElementController<string>("NHS Number", patient.nhsNumber || "");

        this.gpname = new FormElementController<string>("GP Name", patient.generalPractitioner.name || "");
        this.gpaddress = new FormElementController<string>("GP Address", patient.generalPractitioner.address || "");
        this.gppostcode = new FormElementController<string>("GP Postcode", patient.generalPractitioner.postCode || "");
        this.gpphone = new FormElementController<string>("GP Phone", patient.generalPractitioner.phoneNumber || "");
        
    }

    public Load(patient: PatientDto) {
        this.dob =  new FormElementController<Date>("Dob", patient.dob);
    }
    public async submit() :Promise<void> {
        if (!this.isValid()) {

            console.log("Form has errors");
            return;
        }

        this.patient.id = this.patient.id;
        
        this.patient.title = this.title.value;
        this.patient.firstName = this.firstName.value;
        this.patient.middleName = this.middleName.value;
        this.patient.lastName = this.lastName.value;
        this.patient.dob = this.dob.value;
        this.patient.sex = this.sex.value;
    
        this.patient.notes = this.notes.value;
        this.patient.allergies = this.allergies.value;
        this.patient.nhsNumber = this.nhsnumber.value;
   
        this.patient.generalPractitioner = new GeneralPractitioner();
        this.patient.generalPractitioner.name = this.gpname.value;
        this.patient.generalPractitioner.address = this.gpaddress.value;
        this.patient.generalPractitioner.postCode = this.gppostcode.value;
        this.patient.generalPractitioner.phoneNumber = this.gpphone.value;

        this.patient.imageData = this.image;
        console.log(this.patient);
        var dal = new Dal();
        if (this.IsNew) {
            return dal.CreatePatient(this.carehomeId, this.patient);
        }
        else {
            return dal.UpdatePatient(this.patient);
        }
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/carehome-patients/create/carehome-patient-create-controller.ts